import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";

const ModalAddLocation = ({ show, onHide, add, edit, refClinics, refLocation, clearForm, editedLocation }) => {

    const [type, setType] = useState('bu')
    const [clinic, setClinic] = useState(null)
    const [parent, setParentId] = useState(null)
    const [name, setName] = useState('')
    const [latitude, setLatitude] = useState('')
    const [longitude, setLongitude] = useState('')

    useEffect(() => {
        setType('bu')
        setClinic(null)
        setParentId(null)
        setName('')
        setLatitude('')
        setLongitude('')
    }, [clearForm])

    useEffect(() => {
        if (editedLocation) {
            console.log(editedLocation.name)
            setType(editedLocation.type)
            setClinic(editedLocation.registration_clinic_id)
            setParentId(editedLocation.parent_id)
            setName(editedLocation.name)
            setLatitude(editedLocation.lat)
            setLongitude(editedLocation.lng)
        }
    }, [editedLocation])

    useEffect(() => {
        if (type === 'bu') {
            if (!editedLocation) {
                setName('')
            }
        }
        else {
            setName(refClinics.find(v => v.id === +clinic)?.name ?? '')
        }
    }, [type, clinic])

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="modal-user"
        >
            <ModalHeader closeButton>
                <ModalTitle>
                    <h3>{editedLocation ? 'Edit' : 'Add'} Location</h3>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className="row">
                    <div className="col-12">
                        <div className={'form-group'}>
                            <b>Tipe</b>
                            <select className={'form-control'} onChange={e => setType(e.target.value)} value={type} disabled={!!editedLocation}>
                                <option value={'ro'}>Ruangan</option>
                                <option value={'bu'}>Bangunan</option>
                            </select>
                        </div>
                        <div className={`form-group ${type === 'ro' ? '' : 'd-none'}`}>
                            <b>Poli</b>
                            <select className={'form-control'} onChange={e => setClinic(e.target.value)} value={clinic} disabled={!!editedLocation}>
                                <option key={`c012`} value='0'>Pilih klinik</option>
                                {
                                    refClinics.map((v, k) => (<option key={`c${k}`} value={v.id}>{v.clinic.name}</option>))
                                }
                            </select>
                        </div>
                        <div className={`form-group ${type === 'ro' ? '' : 'd-none'}`}>
                            <b>Induk</b>
                            <select className={'form-control'} onChange={e => setParentId(e.target.value)} value={parent} disabled={!!editedLocation}>
                                {
                                    refLocation.map((v, k) => (<option key={`l${k}`} value={v.id}>{v.name}</option>))
                                }
                            </select>
                        </div>
                        <div className={`form-group ${type === 'ro' ? 'd-none' : ''}`}>
                            <b>Nama Bangunan</b>
                            <input type={"text"} className={'form-control'} value={name} onChange={e => setName(e.target.value)} />
                        </div>
                        <div className={'form-group'}>
                            <b>Latitude</b>
                            <input type={"number"} className={'form-control'} value={latitude} onChange={e => setLatitude(e.target.value)} />
                        </div>
                        <div className={'form-group'}>
                            <b>Longitude</b>
                            <input type={"number"} className={'form-control'} value={longitude} onChange={e => setLongitude(e.target.value)} />
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="row">
                    <div className="col-12">
                        <button
                            type="button"
                            onClick={onHide}
                            className="btn btn-outline-secondary"
                        >
                            Batal
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                if (editedLocation) {
                                    edit({
                                        id: editedLocation.id,
                                        registration_clinic_id: clinic,
                                        parent_id: type === 'bu' ? null : parent,
                                        type: type,
                                        lat: latitude,
                                        lng: longitude,
                                        name,
                                    })
                                }
                                else {
                                    add({
                                        registration_clinic_id: clinic,
                                        parent_id: type === 'bu' ? null : parent,
                                        type: type,
                                        lat: latitude,
                                        lng: longitude,
                                        name,
                                    })
                                }
                            }}>
                            Submit
                        </button>
                    </div>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default ModalAddLocation